import { Box, useTheme } from "@mui/material";
import {
  useEffect,
  useState,
} from "react";
import { tokens } from "../../../../../../../theme";
import Text from "../../../../../../../components/theme/text/Text";
import { useTranslation } from "react-i18next";
import Subheading from "../../../../../../../components/theme/text/Subheading";
import NumberSetting from "../../../../../../../components/global/Settings/NumberSetting";
import StringSetting from "../../../../../../../components/global/Settings/StringSetting";
import { useGetSettingsQuery, useGetSettingsForRelationQuery } from "../../../../../../../newapi/global/generalApiSlice";
import DropdownSetting from "../../../../../../../components/global/Settings/DropdownSetting";
import { useGetInvoiceProductsSelectQuery } from "../../../../../../../newapi/financial/invoiceProductSlice";
import { IntegrationInstructionsOutlined } from "@mui/icons-material";
import BoolSetting from "../../../../../../../components/global/Settings/BoolSetting";
import SettingsSaveButton from "../../../../../../../components/global/Settings/SettingsSaveButton";
import useManualSettingsSave from "../../../../../../../components/global/Settings/useManualSettingsSave";

const Integrations = ( props ) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [view, setView] = useState({
    title: 'integrations',
    icon: <IntegrationInstructionsOutlined />,
  });

  const { data: settings} = useGetSettingsQuery("webshop_sync");
  const { data: settingsBol} = useGetSettingsQuery("bol_orders");
  const { data: settingsBolReplenishment} = useGetSettingsQuery("bol_replenishment");
  const { data: relationSettings } = useGetSettingsForRelationQuery();
  const { handleChange, hasChanges, isSaving, save } = useManualSettingsSave();
  const { data: invoiceProducts, productsIsLoading } = useGetInvoiceProductsSelectQuery();

  const [invoiceProductOptions, setInvoiceProductOptions] = useState([]);
  useEffect(() => {
    if (invoiceProducts && invoiceProducts.length > 0) {
      setInvoiceProductOptions([{id: null, name: t('none')}, ...invoiceProducts]);
    }
  }, [invoiceProducts])

  useEffect(() => {
    props.replaceView({
        ...props.config,
    },);

    return () => {};
  }, []);

  return (
    <Box
      sx={{
        height: 1,
        "@media screen and (max-width: 47.9375em)": {
          paddingTop: 0,
          paddingX: 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: 1,
          gap: 2,
          overflow: "hidden",
          background:
            theme.palette.mode === "dark"
              ? colors.grey[300]
              : colors.bg["tertiary"],
          paddingX: 2,
          paddingTop: 4,
          height: 1,
          position: "relative",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          "@media screen and (max-width: 47.9375em)": {
            paddingTop: 0,
            paddingX: 0,
            background: colors.bg["tertiary"],
          },
          "& .carrier": {
            paddingLeft: 0,
            marginRight: 2,
          },
          "& [aria-label='Carrier']": {
            paddingLeft: 0,
            marginRight: 2,
          },
        }}
      >
        <Box
          sx={{
            paddingX: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* The heading is the part that gives way on a phone; the save action has to stay
              reachable there, so the breakpoint sits on the text rather than on the row. */}
          <Box
            sx={{
              "@media screen and (max-width: 47.9375em)": {
                display: "none",
              },
            }}
          >
            <Subheading>{t("core_integrations_title")}</Subheading>
            <Text light>{t("core_integrations_subtitle")}</Text>
          </Box>
          <SettingsSaveButton onClick={save} isLoading={isSaving} disabled={!hasChanges} />
        </Box>
        
        <Box
          sx={{
            background:
              theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
            flex: 1,
            display:"flex",
            flexDirection:"column",
            gap:3,
            pt:3,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            "@media screen and (max-width: 47.9375em)": {
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0],
            },
          }}
        >
          <Box
            sx={{
              background:
                theme.palette.mode === "dark"
                  ? colors.grey[400]
                  : colors.grey[0],
              px: 3,
              display:"flex",
              flexDirection:"column",
              gap:3,
              "@media screen and (max-width: 47.9375em)": {
                gap:2.5,
              },
            }}
          >
            <BoolSetting 
            manualSave
            onChange={handleChange}
            settings={settings} 
            skey="webshop_sync_create_products"
              explainer={true}
              explainerTitle={t("webshop_sync_create_products_explainer_title")}
              explainerText={t("webshop_sync_create_products_explainer_text")}/>
              <BoolSetting 
            manualSave
            onChange={handleChange}
            settings={settings} 
            skey="webshop_sync_update_products"
              explainer={true}
              explainerTitle={t("webshop_sync_update_products_explainer_title")}
              explainerText={t("webshop_sync_update_products_explainer_text")}/> 
              <BoolSetting 
              manualSave
              onChange={handleChange}
              settings={settingsBol} 
              skey="bol_orders_earliest_handover"/> 
              <BoolSetting 
              manualSave
              onChange={handleChange}
              settings={settingsBol}
              skey="bol_orders_block_snooze_from_warehouse"/>
              <BoolSetting
              manualSave
              onChange={handleChange}
              settings={settingsBolReplenishment}
              skey="bol_replenishment_pickup_enabled"/>
              <BoolSetting
              manualSave
              onChange={handleChange}
              settings={relationSettings}
              skey="relation_edit_pickingslip"
              relationId={-1}
              defaultValue="true"/>
      </Box>
      </Box>
      </Box>
      </Box>
  );
};

export default Integrations;